import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  description: {
    id: 'studio.QprlXT',
    defaultMessage: 'Go through the appsemble training to start building awesome apps.',
  },
  title: {
    id: 'studio./+axU7',
    defaultMessage: 'Training',
  },
});
